import { SET_SHOULD_REDIRECT_POST_SSO } from '_acaSrc/store/login.store';
import { C_REG_MERGE } from '_acaSrc/utility/constants';
import { getWindow } from '_acaSrc/utility/DOM';
import { setQueryParamValue } from '_acaSrc/utility/http';

export default class NavigationService {
    constructor(store) {
        this.store = store;
    }

    navigateToSso(ssoUrl, regMergeSource, setSubmitting) {
        setSubmitting(true);
        this.store.commit(`login/${SET_SHOULD_REDIRECT_POST_SSO}`, true);
        const mergeRedirectUrl = setQueryParamValue(
            ssoUrl,
            C_REG_MERGE.REG_MERGE_SOURCE,
            regMergeSource
        );
        getWindow().location.href = mergeRedirectUrl;
    }
}
